import { useEffect, useState } from 'react'
import { fetchNcfdStatus } from '../../lib/marketData/ncfdClient.js'
import { ncfdStatusLines } from '../../lib/marketData/ncfdContract.js'

export default function NcfdStatusPanel() {
  const [state, setState] = useState({ snapshot: null, loading: true, failed: false })
  useEffect(() => {
    let disposed = false
    let controller = null
    const load = async () => {
      if (disposed || controller || document.visibilityState === 'hidden') return
      controller = new AbortController()
      const timeout = setTimeout(() => controller?.abort(), 10000)
      try {
        const snapshot = await fetchNcfdStatus({ signal: controller.signal })
        if (!disposed) setState({ snapshot, loading: false, failed: false })
      } catch {
        if (!disposed) setState(previous => ({ ...previous, loading: false, failed: true }))
      } finally {
        clearTimeout(timeout)
        controller = null
      }
    }
    load()
    const timer = setInterval(load, 60000)
    document.addEventListener('visibilitychange', load)
    window.addEventListener('online', load)
    return () => {
      disposed = true
      controller?.abort()
      clearInterval(timer)
      document.removeEventListener('visibilitychange', load)
      window.removeEventListener('online', load)
    }
  }, [])
  const lines = ncfdStatusLines(state.snapshot, state)
  return <section aria-label="NCFD collector status" data-testid="ncfd-status-pane"
    className="min-h-20 min-w-0 rounded-lg border border-border/50 bg-canvas p-3 lg:h-full">
    <div role="status" aria-live="polite" className="font-mono text-xs leading-5">
      <p className="text-ink">{lines[0]}</p>
      {lines[1] && <p className="text-inkMuted">{lines[1]}</p>}
    </div>
  </section>
}
